export class EnquiryTypeModel {
  constructor(
    public showPackagingTab = false,
    public showTransportTab = false,
    public packagingOnly = false,
    public tranportOnly = false,
    public showCollection = false
  ) {}
}

export class QuoteTypeModel {
  constructor(
    public isHauilerAssigned = false,
    public isHaulierAwarded = false,
    public showAssignBtn = false,
    public showAwardBtn = false,
    public showSaveBtn = false
  ) {}
}
